import { render, staticRenderFns } from "./BetgameEditSpecialQuestions.vue?vue&type=template&id=739672a4&scoped=true"
import script from "./BetgameEditSpecialQuestions.vue?vue&type=script&lang=js"
export * from "./BetgameEditSpecialQuestions.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditSpecialQuestions.vue?vue&type=style&index=0&id=739672a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739672a4",
  null
  
)

export default component.exports